module.exports = __webpack_public_path__ + "media/D2 Plaza 10.430e2ddb.mp3";